import React from 'react'
import classes from './DutyTable.module.css'
import { Table, Tbody, Thead, Tr, Th, Grid, Td, Heading } from '@chakra-ui/react'
import DutyCell from '../DutyCell/DutyCell'
import { useDutyStore } from '../../store/dutyStore'
import { getWeekDateList } from '../../utils/dutyHelper'


function DutyTable({week}) {
    const duty = useDutyStore(state => state.duty)
    console.log('DutyTable duty:', duty)
    const weekDateList = getWeekDateList(duty?.weeks, week)

    return (
        duty && duty?.weeks?.length > 0 && duty?.weeks?.length > week
        ?
        <div className={classes.container}>
            <Table>
                <Thead>
                    <Tr>
                        <Th>
                            Понедельник
                            <p>{weekDateList[0]}</p>
                        </Th>
                        <Th>
                            Вторник
                            <p>{weekDateList[1]}</p>
                        </Th>
                        <Th>
                            Среда
                            <p>{weekDateList[2]}</p>
                        </Th>
                        <Th>
                            Четверг
                            <p>{weekDateList[3]}</p>
                        </Th>
                        <Th>
                            Пятница
                            <p>{weekDateList[4]}</p>
                        </Th>
                        <Th>
                            Суббота
                            <p>{weekDateList[5]}</p>
                        </Th>
                        <Th>
                            Воскресенье
                            <p>{weekDateList[6]}</p>
                        </Th>
                    </Tr>
                </Thead>
                <Tbody>
                    <Tr>
                        {duty.weeks[week].days.map((day, index) => (
                            day && day.is_this_month && day?.times?.length > 0
                            ?
                            <Td key={`days${day.day_id + index}`}>
                                <Grid className={classes.day}>
                                    {day.times.map((time) => (
                                        <DutyCell time={time} key={`time${time.time_id}`} />
                                    ))}
                                </Grid>
                            </Td>
                            :
                            <Td key={`days${index}`} />
                        ))}
                    </Tr>
                </Tbody>
            </Table>
        </div>
        :
        <Heading>Ошибка при загрузке расписания</Heading>
    )
}

export default DutyTable
